<template>
  <div class="list-item-page" @click="onClickRow">
    <v-chip class="chip mr-2" label pill small :color="colors[page_publish]">
      {{ page_publish }}
    </v-chip>

    <div class="page-title">{{ page_menu_title }}<TagsRow :tags="tags" /></div>
    <div class="page-date">{{ createdDate }}</div>
    <div class="page-date">{{ updatedDate }}</div>
    <div class="page-date">{{ updated_by }}</div>
  </div>
</template>

<script>
import { dateParseJustDate as dateParse } from '../../lib/misc'
import { colors } from '@/assets/data/colors'
import TagsRow from '@/components/shared/TagsRow.vue'

export default {
  name: 'LatestPagesListItem',
  props: {
    id: { type: Number },
    page_publish: { type: String },
    page_menu_title: { type: String },
    created_at: { type: String },
    updated_at: { type: String },
    updated_by: { type: String },
    tags: { type: Array },

  },
  components: {
    TagsRow,
  },
  data() {
    return {
      colors,
    }
  },
  computed: {
    createdDate() {
      return dateParse(this.created_at)
    },
    updatedDate() {
      return dateParse(this.updated_at)
    },
  },
  methods: {
    onClickRow() {
      this.$emit('click', this.id)
    },
  },
}
</script>

<style lang="less" scoped>
.list-item-page {
  display: grid;
  grid-template-columns: 75px 1fr 140px 140px 140px;
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 0px;

  padding: 6px 10px;
  border-bottom: #ccc 1px solid;
  background-color: #fff;
  cursor: pointer;
  &:hover {
    background-color: rgb(245, 245, 245);
  }
  .chip {
    display: flex;
    justify-content: center;
  }
  .page-title {
    display: inline-flex;
    gap:5px;
    flex-wrap: wrap;
    font-weight: 500;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .page-date {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
}
</style>
